import StoreProvider, { store } from 'store/store';
import { MetaType } from 'store/modules/Meta/types';

const usePolicy = () => {
  const state = store.getState();
  const policyPlatforms =
    StoreProvider.selectors.metaSelectors.policyPlatforms(state);
  const policyProviders =
    StoreProvider.selectors.metaSelectors.policyProviders(state);
  const policyTypes = StoreProvider.selectors.metaSelectors.policyTypes(state);

  const humanizePolicyPlatform = (value: string | number) => {
    if (!value) return '';
    const filtered = policyPlatforms.filter(
      (platform: MetaType) => Number(platform.value) === Number(value)
    );

    return filtered[0] ? filtered[0].name : '---';
  };

  const humanizePolicyProvider = (value: string | number) => {
    if (!value) return '';
    const filtered = policyProviders.filter(
      (platform: MetaType) => Number(platform.value) === Number(value)
    );
    return filtered[0] ? filtered[0].name : '---';
  };

  const humanizePolicyType = (value: string | number) => {
    if (!value) return '';
    return policyTypes.filter(
      (platform: MetaType) => Number(platform.value) === Number(value)
    )[0].name;
  };

  return { humanizePolicyPlatform, humanizePolicyProvider, humanizePolicyType };
};

export default usePolicy;
